import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import { Button, Chip, Tooltip } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import { searchValuesAtom } from '../../Atoms';
import CustomDialog from '../Dialog/CustomDialog';
import FiltersSelection from './FiltersSelection';

const filtersActive = (filtersObject) => {
  if (!filtersObject) return 0;
  const keys = Object.keys(filtersObject).filter((key) => {
    if (key === 'sortValue') return false;
    if (key === 'searchBox') return false;

    if (Array.isArray(filtersObject[key])) {
      return key === 'ratingValue'
        ? filtersObject[key].length < 6
        : filtersObject[key].length > 0;
    }
    return (
      filtersObject[key] ||
      filtersObject[key] === 0 ||
      filtersObject[key] === false
    );
  });

  return keys.length;
};

const FiltersButton = function FiltersButton({
  hidden = false,
  defaultFilters = null,
  // defaultRating = null,
  customFilters = null,
  currentSection = 'CUSTOMERS',
}) {
  const intl = useIntl();

  const setSearchValues = useSetAtom(searchValuesAtom);
  const [open, setOpen] = useState(false);
  const [onHover, setOnHover] = useState(false);

  const handleOpenFiltersMenu = () => {
    setOpen(true);
  };

  const handleCloseFilterMenu = () => {
    setOpen(false);
  };

  const toggleHover = (newValue) => () => {
    setOnHover(newValue);
  };

  const handleClearFilters = (e) => {
    e.stopPropagation();
    const filters = { ...defaultFilters };
    Object.keys(filters).forEach((key) => {
      if (key !== 'sortValue' && key !== 'searchBox') filters[key] = null;
    });
    setSearchValues(filters);
  };

  const activeFiltersCount = filtersActive(defaultFilters);
  return (
    !hidden && (
      <>
        <Tooltip title={intl.messages.FILTERS}>
          <Button
            sx={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              padding: '6px 8px',
              gap: '8px',
              fontSize: '13px',
              width: '110px',
            }}
            onMouseEnter={toggleHover(true)}
            onMouseLeave={toggleHover(false)}
            variant={activeFiltersCount === 0 ? 'outlined' : 'contained'}
            onClick={handleOpenFiltersMenu}
          >
            <span style={{ flexGrow: 1 }}>{intl.messages.FILTERS}</span>
            {activeFiltersCount === 0 ? (
              <FilterAltOutlinedIcon />
            ) : (
              <Chip
                size="small"
                label={onHover ? '×' : activeFiltersCount}
                sx={{
                  '&:hover': {
                    bgcolor: '#fff',
                  },
                  bgcolor: '#fff',
                  color: 'primary.main',
                  fontSize: 'inherit',
                  width: '30px',
                }}
                onClick={onHover && handleClearFilters}
              />
            )}
          </Button>
        </Tooltip>
        <CustomDialog
          id="filters-selection-dialog"
          open={open}
          close={handleCloseFilterMenu}
          title={intl.messages.FILTERS}
          icon={<FilterAltRoundedIcon />}
          escapeToClose
          noBackdrop
          maxWidth={false}
          styles={{ content: { flexDirection: 'column' } }}
          disableActions
          showOnly
        >
          {customFilters || (
            <FiltersSelection
              currentSection={currentSection}
              closeMenu={handleCloseFilterMenu}
              defaultFilters={defaultFilters}
              // defaultRating={defaultRating}
              showWaveFilters={currentSection !== 'BIRTHDAYS'}
            />
          )}
        </CustomDialog>
      </>
    )
  );
};

FiltersButton.propTypes = {
  hidden: PropTypes.bool,
  defaultFilters: PropTypes.object,
  // defaultRating: PropTypes.array,
  customFilters: PropTypes.object,
  currentSection: PropTypes.string,
};

export default FiltersButton;
